// 挂载在window上的公共方法
import {formatDateTime,deepClone,numberFormat} from '@/utils/index'

window.deepClone = deepClone

window.formatDateTime = formatDateTime

window.numberFormat = numberFormat


// 校验格式
// 获得当前浏览器的信息
/*
window.BROWSER.versions.trident//IE内核
window.BROWSER.versions.presto//opera内核
window.BROWSER.versions.webKit//苹果、谷歌内核
window.BROWSER.versions.gecko//火狐内核
window.BROWSER.versions.mobile//是否为移动终端
window.BROWSER.versions.ios//ios终端
window.BROWSER.versions.android//android终端或者uc浏览器
window.BROWSER.versions.iPhone//是否为iPhone或者QQHD浏览器
window.BROWSER.versions.iPad//是否iPad
window.BROWSER.versions.webApp//是否web应该程序，没有头部与底部
*/
window.BROWSER = {
  versions: (function () {
    var u = navigator.userAgent, app = navigator.appVersion
    return {// 移动终端浏览器版本信息
      trident: u.indexOf('Trident') > -1, // IE内核
      presto: u.indexOf('Presto') > -1, // opera内核
      webKit: u.indexOf('AppleWebKit') > -1, // 苹果、谷歌内核
      gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1, // 火狐内核
      mobile: !!u.match(/AppleWebKit.*Mobile.*!/) || !!u.match(/AppleWebKit/), // 是否为移动终端
      ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), // ios终端
      android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, // android终端或者uc浏览器
      iPhone: u.indexOf('iPhone') > -1 || u.indexOf('Mac') > -1, // 是否为iPhone或者QQHD浏览器
      iPad: u.indexOf('iPad') > -1, // 是否iPad
      webApp: u.indexOf('Safari') == -1 // 是否web应该程序，没有头部与底部
    }
  })(),
  language: (navigator.browserLanguage || navigator.language).toLowerCase()
}

// 获得ie的版本号
window.BROWSER_IE_versions = function () {
  var UA = navigator.userAgent,
    isIE = UA.indexOf('MSIE') > -1,
    v = isIE ? /\d+/.exec(UA.split(';')[1]) : -1
  return v
}

// 价格格式



// WEBPACK FOOTER //
// ./src/utils/window_commom.js